import ICoreMarqueeScroller from './Classes/ICoreMarquee';
import ICoreMiniSearchWidget from './Classes/ICoreMiniSearchWidget';
import ICoreThemeToggle from './Classes/ICoreThemeToggle';
import ICorePreloader from './Classes/ICorePreloader';
import ICoreScrollToTop from './Classes/ICoreScrollToTop';
import ICoreCountUp from './Classes/ICoreCountUp';
import ICoreProcessSteps from './Classes/ICoreProcessSteps';
import ICoreTrustDashBars from './Classes/ICoreTrustDashBars';
import ICoreReveal from './Classes/ICoreReveal';
import ICoreAPI from './Utils/ICoreAPI';

ICoreThemeToggle.applySavedTheme();
ICorePreloader.init();

/**
 * clickout-event v1.1.2
 * (c) 2020-2023 Mu-Tsun Tsai
 * Released under the MIT License.
 */
!function(){"use strict";const t="on",e="out",n="body",o="stop",s="click",i="apply",r="target",u="prototype",c="Propagation",d="setAttribute",a="relatedTarget",h="addEventListener",p=Symbol(e),l=Object,f=document,m="undefined"!=typeof TouchEvent?TouchEvent:void 0,v=HTMLElement,y=v[u],b=Event[u],E=[s,"dbl"+s,"mousedown","mouseup","touchstart","touchend","pointerdown","pointerup"],w=new Set(E),g=new Set(E.map((n=>t+n+e))),T=(t,e)=>!!e&&t instanceof e,L=(t,e)=>t.contains(e),N=(t,e)=>{for(let n of t)e(n)},S=n=>{T(n,v)&&(n[p]?A(n):N(w,(o=>{let s=t+o+e,i=n.getAttribute(s);i&&!j(n)[s]&&n[d](s,i)})),N(n.childNodes,S))},j=t=>t[p]=t[p]||{},A=t=>{j(t),I.includes(t)||(I.push(t),q=!0)},M=(t,e)=>L(e,t)?1:L(t,e)?-1:0,O=t=>{q&&(I.sort(M),q=!1);let n=t[r];T(t,m)?(t=new m(t.type+e,t))[a]=n:t=new t.constructor(t.type+e,l.assign({},t,{[a]:n})),t[o]=[],N(I,(e=>{L(e,n)||t[o].some((t=>L(t,e)))||e.dispatchEvent(t)}))},P=e=>function(){let n=this,s=n.type;e[i](n),g.has(t+s)&&n[o].push(n[r])},k=(t,e,n)=>t[e]=n(t[e]);function H(e){let n=this[p][t+e.type];n&&n[i](this,[e])}let I=[],q=!1,x=f.createElement(n);N(w,(n=>{f[h](n,O,{passive:!0,capture:!0});let o=t+n+e;l.defineProperty(y,o,{get(){return this[p][o]},set(t){this[h](n+e,H),this[p][o]="object"==typeof t?t.handleEvent:t}})})),k(y,h,(e=>function(...n){g.has(t+n[0])&&A(this),e[i](this,n)})),k(y,d,(e=>function(n,o){g.has(n)?(e[i](x,[t+s,o]),this[n]=x[t+s]):e[i](this,[n,o])})),k(b,o+c,P),k(b,o+"Immediate"+c,P),new MutationObserver((t=>{N(t,(t=>{N(t.addedNodes,S),N(t.removedNodes,(t=>{T(t,v)&&(I=I.filter((e=>!L(t,e))))}))}))})).observe(f.documentElement,{childList:!0,subtree:!0}),S(f[n])}();

function removeTitleFromImage() {
    if ( document.querySelectorAll('img').length > 0 ) {
        document.querySelectorAll('img').forEach(function(image) {
            image.removeAttribute('title');
        });
    }
    if ( document.querySelectorAll('a.dt-pswp-item').length > 0 ) {
        document.querySelectorAll('a.dt-pswp-item').forEach(function(link) {
            link.removeAttribute('title');
        });
    }
}


window.$iCore = window.$iCore || {};
window.$iCore.helper = ICoreAPI;
window.$iCore.plugins = {};
window.$iCore.animatedSection = {};
window.$iCore.actions = {
    scheduleAConsultation: (element, event) => {
        event.preventDefault();

        const calendlyUrl = typeof iCoreAppJs !== 'undefined' ? iCoreAppJs.calendly_url : '';

        if (!calendlyUrl || !window.hasOwnProperty('Calendly')) {
            return;
        }

        Calendly.showPopupWidget(calendlyUrl);
    },
    initMarquee: function(scrollerId) {
        let marquee = new ICoreMarqueeScroller(scrollerId);
    },
    initTrustDashBars: function(rootId) {
        ICoreTrustDashBars.initById(rootId);
    },
    initializeLenis: function() {
        window.$iCore.lenis = new Lenis();
        window.$iCore.lenis.on('scroll', (evt) => {
            ScrollTrigger.update();
        });

        function raf(time) {
            window.$iCore.lenis.raf(time);
            requestAnimationFrame(raf);
        }
        requestAnimationFrame(raf);
    },
    destroyLenis: function() {
        window.$iCore.lenis.destroy();
        window.$iCore.lenis = null;
    },
    openSearchWidget: (element, evt) => {
        if ( window.$iCore.plugins.hasOwnProperty('icore_search_mini_widget') ) {
            window.$iCore.plugins.icore_search_mini_widget.open();
            return;
        }

        window.$iCore.plugins.icore_search_mini_widget = new ICoreMiniSearchWidget(element, {});
        window.$iCore.plugins.icore_search_mini_widget.open();
    },
    onAddCalendlyPopupElement: function(element) {
        window.$iCore.actions.destroyLenis();
        document.body.classList.add('calendly-popup--isActive');
    },
    onRemoveCalendlyPopupElement: function(element) {
        initLenis();
        document.body.classList.remove('calendly-popup--isActive');
    }
}

function initLenis() {
    window.$iCore.actions.initializeLenis();
}

function initGSAP() {
    gsap.registerPlugin(ScrollTrigger);
    gsap.registerPlugin(TextPlugin);

    window.$iCore.helper.animator = gsap;

    gsap.ticker.add((time)=>{
        // window.$iCore.lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0);
}

function initICOREWPCF7Events() {
    document.addEventListener('wpcf7invalid', function(event) {
        event.preventDefault();
        ICoreAPI.toast.show(event.detail.apiResponse.message, "error", "Error");
    }, false);

    document.addEventListener('wpcf7spam', function(event) {
        event.preventDefault();
        ICoreAPI.toast.show(event.detail.apiResponse.message, "warning", "Spam detected");
    }, false);

    document.addEventListener('wpcf7mailsent', function(event) {
        event.preventDefault();
        ICoreAPI.toast.show(event.detail.apiResponse.message, "success", "Success", "topCenter", 3000, {
            onClosed: function() {

            }
        });
    }, false);

    document.addEventListener('wpcf7mailfailed', function(event) {
        event.preventDefault();
        ICoreAPI.toast.show(event.detail.apiResponse.message, "error", "Error");
    }, false);
}

function headerOffset(additionalOffset = 0, unit = 'px') {
    let header = document.querySelector('.masthead.inline-header');
    if (header) {
        const offserHeight = header.offsetHeight;
        return `${offserHeight+additionalOffset}${unit}`;
    }
    return `${additionalOffset}${unit}`;
}

class BaseAnimator {
    startOffset = null;
    animator = null;
    animatedSections = {};
    constructor() {
        this.startOffset = 10;
        this.animator = window.$iCore.helper.animator;
        this.animatedSections = window.$iCore.animatedSection;
    }

    beginSequence() {
        this.initialize();
    }

    initialize() {
        throw new Error('[BaseAnimator] you must declare an initialize function in your subclass.');
    }
}

class ServicesXScrollAnimator extends BaseAnimator {
    container = null;
    elementContainer = null;
    constructor(container) {
        super();
        this.container = container;
        if ( !this.container ) {
            throw new Error(`[ServicesXScrollAnimator]: Container element not found`);
        }
        this.elementContainer = this.container.querySelector('.flex-box-wrapper');
        if ( !this.elementContainer ) {
            throw new Error(`[ServicesXScrollAnimator]: Element container element not found`);
        }

        this.beginSequence();
    }

    initialize() {
        let additionalOffset = 0;



        this.animator.to(this.elementContainer, {
            x: () => -(this.elementContainer.scrollWidth - this.container.offsetWidth),
            ease: 'none',
            scrollTrigger: {
                trigger: this.container,
                start: `top ${this.startOffset + additionalOffset}`,
                end: () => `+=${this.elementContainer.scrollWidth - this.container.offsetWidth}`,
                scrub: true,
                pin: true,
                // anticipatePin: 1
            }
        });
    }
}

const animatorClasses = {
    'ServicesXScrollAnimator': ServicesXScrollAnimator,
};

document.addEventListener('DOMContentLoaded', function() {
    initICOREWPCF7Events();
    initLenis();
    removeTitleFromImage();

    const themeTog = document.getElementById('themeTog');
    if (themeTog) {
        window.$iCore.plugins.icore_theme_toggle = new ICoreThemeToggle(themeTog);
    }

    const toTop = document.getElementById('toTop');
    if (toTop) {
        window.$iCore.plugins.icore_scroll_to_top = new ICoreScrollToTop(toTop);
    }

    window.$iCore.plugins.icore_count_up = new ICoreCountUp();
    window.$iCore.plugins.icore_reveal = new ICoreReveal();

    document.querySelectorAll('.icore-process-steps').forEach((root) => {
        new ICoreProcessSteps(root);
    });

    ICoreTrustDashBars.initAll();

    // ANIMATIONS
    const iCoreGSAPContainers = document.querySelectorAll(".icore_gsap_container");
    if ( iCoreGSAPContainers.length > 0 ) {
        [...iCoreGSAPContainers].forEach(container => {
            let animatorClassName = container.getAttribute('data-animator');
            let animatorUniqueId = container.getAttribute('data-animator-uid');
            let AnimatorClass = animatorClasses[animatorClassName];

            if (AnimatorClass) {
                window.$iCore.animatedSection[`sec_${animatorUniqueId}`] = new AnimatorClass(container);
            } else {
                console.error(`Animator class "${animatorClassName}" not found for section with ID "${animatorUniqueId}`);
            }
        });
    }

    const calendlyElementObserver = new MutationObserver((mutationsList) => {
        mutationsList.forEach((mutation) => {
            // Check if nodes are added
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1 && node.classList.contains('calendly-overlay')) {
                    window.$iCore.actions.onAddCalendlyPopupElement(node);
                }
            });

            // Check if nodes are removed
            mutation.removedNodes.forEach((node) => {
                if (node.nodeType === 1 && node.classList.contains('calendly-overlay')) {
                    window.$iCore.actions.onRemoveCalendlyPopupElement(node);
                }
            });
        });
    });

    calendlyElementObserver.observe(document.body, { childList: true, subtree: true });
});